import { useCallback } from 'react';
import { Usuario } from '../types';

type TipoPermiso = 'materiales' | 'fotos' | 'documentos' | 'tareas';

export const usePermisos = (usuario: Usuario | null) => {
  const verificarPermisosObra = useCallback(
    (obraId: string) => {
      if (!usuario) return false;
      const role = usuario.role?.toUpperCase();
      if (role === 'ADMIN') return true;
      if (usuario.puedeVerTodasLasObras) return true;

      // Check if obraId is in the array of assigned works
      return usuario.obrasAsignadas?.includes(obraId);
    },
    [usuario]
  );

  const verificarPermisosTipo = useCallback(
    (tipo: TipoPermiso) => {
      if (!usuario) return false;
      const role = usuario.role?.toUpperCase();
      if (role === 'ADMIN') return true;

      if (role === 'EDITOR') {
        // Editors have write access to everything in their assigned works
        return true;
      }

      if (role === 'LECTOR') {
        // Lectors usually have read-only access, but this function checks for "generic" permission.
        // If this is used for "can I see this tab?", then yes.
        // If used for "can I write?", then no.
        // Assuming this is used for visibility of tabs/sections:
        return true;
      }

      return false;
    },
    [usuario]
  );

  const puedeEditar = useCallback(() => {
    if (!usuario) return false;
    const role = usuario.role?.toUpperCase();
    return role === 'ADMIN' || role === 'EDITOR';
  }, [usuario]);

  return { verificarPermisosObra, verificarPermisosTipo, puedeEditar };
};